
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#10C6B4","d":"M14.472 2.866l-4-2.866H5.528l-4 2.866L0 7.5l1.528 4.635 4 2.865h4.944l4-2.865L16 7.5z"}}),_c('path',{attrs:{"d":"M12.23 4.93l-3.217 5.804a1.233 1.233 0 01-.945.65l-.186.016c-.35 0-.653-.13-.91-.387l-2.586-2.57A1.252 1.252 0 014 7.532c0-.352.129-.656.386-.914a1.25 1.25 0 01.913-.388c.35 0 .655.13.913.388L7.59 7.979l2.382-4.303c.166-.31.424-.515.774-.619a1.23 1.23 0 01.99.109c.31.165.513.423.611.774.098.35.06.68-.116.99z","fill":"#FFF"}})])])
          )
        }
      }
    